import { ToastOptions, WithId } from "./types";

class ToastApi {
  private idCounter = 0;
  private toasts: WithId<ToastOptions>[];
  private subscribers: ((toasts: WithId<ToastOptions>[]) => void)[];

  constructor() {
    this.toasts = [];
    this.subscribers = [];
  }

  subscribe(subscriber: (toasts: WithId<ToastOptions>[]) => void) {
    this.subscribers.push(subscriber);

    return () => this.unsubscribe(subscriber);
  }

  unsubscribe(subscriber: (toasts: WithId<ToastOptions>[]) => void) {
    this.subscribers = this.subscribers.filter(cb => cb !== subscriber);
  }

  notify() {
    this.subscribers.forEach(cb => cb(this.toasts));
  }

  add(toast: ToastOptions) {
    const id = this.idCounter++;
    const newToast = { ...toast, id };
    this.toasts = [...this.toasts, newToast];
    this.notify();
    return newToast;
  }

  remove(id: number) {
    this.toasts = this.toasts.filter(toast => toast.id !== id);
    this.notify();
  }

  reset() {
    this.toasts = [];
    this.notify();
  }
}

export const toastApi = new ToastApi();
